import "./CardProductItem.css.ts.vanilla.js";
var r = "_1qxd3el8", a = "_1qxd3el7", d = "_1qxd3el5", l = "_1qxd3el6", i = "_1qxd3el2", t = "_1qxd3el3", v = "_1qxd3el0", x = "_1qxd3el4", o = "_1qxd3el1";
export {
  r as buttonIcon,
  a as buttonLink,
  d as description,
  l as image,
  i as inactiveCard,
  t as info,
  v as root,
  x as title,
  o as visuallyHidden
};
